import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const DarmkrebsPage = () => {
  return (
    <Layout>
      <PageHero
        title="Darmkrebsvorsorge: Prävention ist entscheidend"
        subtitle="Wir beraten Sie zur Vorbeugung von Darmkrebs und koordinieren die notwendigen Untersuchungen."
        backgroundImage="/images/Darm Untersuchung.webp"
        ctaText="Darmkrebsvorsorge-Beratung buchen"
      />

      <ContentSection
        title="Wichtige Prävention für Ihre Gesundheit"
        content="Darmkrebs ist eine der häufigsten Krebsarten, aber durch Vorsorgeuntersuchungen wie die Darmspiegelung kann er effektiv verhindert oder im Frühstadium erkannt werden. Wir beraten Sie zu den empfohlenen Vorsorgeintervallen und den verfügbaren Methoden und unterstützen Sie bei der Koordination der notwendigen Schritte."
        image="/images/Darm Untersuchung.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Beratung zur Darmkrebsprävention in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh informiert und unterstützt Sie bei der Darmkrebsvorsorge."
      />

      <CTASection
        title="Nehmen Sie die Darmkrebsvorsorge ernst"
        subtitle="Vereinbaren Sie einen Beratungstermin, um mehr über die Prävention zu erfahren."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default DarmkrebsPage;
